import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  IMap,
  IRuntimeError,
  Error as TelemetryError,
  TriggerAction,
  Action,
  TelemetryEvent,
} from '@rccl/telemetry-events';
import { TelemetryContextService } from '@rccl/telemetry-angular';
import { EndPointsErrorLookup } from '~app/shared/types/endpoints-error-codes.type';
import { ITelemetryContextError } from '~app/shared/interfaces/telemetry-context-error.interface';
import { ITelemetryErrorCode } from '~app/shared/interfaces/telemetry-error-code.interface';
import { errorCodesList } from '~app/shared/constants/telemetry-error-codes-list.constant';
import { unknownErrorCode } from '../../constants/telemetry-error-codes-list.constant';

@Injectable({
  providedIn: 'root',
})
export class SplunkService {
  constructor(private readonly telemetryContext: TelemetryContextService) {}

  public initializeContext(label: string[] | string, value: any): IMap<string | number> {
    const context: IMap<string | number> = {};
    const labels = [].concat(label);
    const values = [].concat(value);

    for (let k = 0; k < labels.length; k++) {
      context[labels[k]] = values[k];
    }
    return context;
  }

  public getTelemetryErrorObject(err: HttpErrorResponse): ITelemetryContextError {
    const { developerMessage, internalMessage, ...rest } = err.error?.errors?.[0] || {};
    return {
      ...rest,
      devError: developerMessage || '',
      message: err.message || internalMessage || '',
      status: err.status || 600,
    };
  }

  public errorByLookUp(lookup: EndPointsErrorLookup, runtimeError?: IRuntimeError): TelemetryError {
    const event = this.getTelemetryError(lookup, runtimeError);
    this.dispatchEvent(event, TriggerAction.Error);
    return event;
  }

  public getTelemetryError(lookup: EndPointsErrorLookup, runtimeError?: IRuntimeError): TelemetryError {
    const error: ITelemetryErrorCode = this.findRuntimeError(lookup);

    if (!error) return;

    return new TelemetryError({
      tag: error.tag,
      errId: error.code,
      group: error.group,
      errMsg: error.label,
      stack: runtimeError && runtimeError.stack,
      context: runtimeError && runtimeError.context,
    });
  }

  private dispatchEvent(telemetryEvent: TelemetryEvent, telemetryAction: TriggerAction): void {
    const action = new Action({
      data: telemetryEvent,
      subType: telemetryAction,
      actionType: 200,
    });
    this.telemetryContext.dispatch.emit(action);
  }

  private findRuntimeError(lookup: EndPointsErrorLookup): ITelemetryErrorCode {
    const error = errorCodesList.find(err => err.lookup === lookup);
    return error ?? unknownErrorCode;
  }
}
